import {css} from 'lit';

export default css`

.mobile-bar {
  display: flex;
  align-items: center;
  overflow: hidden;
  min-height: 3.25rem;
  background-color: #022851;
}
@media (min-width: 992px) {
  .mobile-bar {
    display: none;
  }
}
.mobile-bar__nav-toggle {
  position: relative;
  display: flex;
  flex-shrink: 0;
  margin-right: 1rem;
  background-color: #13639e;
}
.mobile-bar__nav-toggle:before {
  position: absolute;
  right: -1rem;
  width: 1rem;
  height: 100%;
  background-color: #022851;
  content: "";
  transform: skewX(16deg);
}
.mobile-bar__nav-toggle:after {
  width: 1rem;
  margin-left: 0.5rem;
  background-color: #14447a;
  content: "";
  transform: skewX(16deg);
}
.mobile-bar__fixed-site-name {
  z-index: 1;
  visibility: hidden;
  width: 0;
  height: 0;
  padding-right: 1rem;
  color: #fff;
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1;
  opacity: 0;
  transition: visibility 0s, opacity 0.5s linear;
}
@media (min-width: 768px) {
  .mobile-bar__fixed-site-name {
    font-size: 1.25rem;
    line-height: 1;
  }
}
.is-fixed .mobile-bar__fixed-site-name {
  visibility: visible;
  width: auto;
  height: auto;
  opacity: 1;
}
.mobile-bar__fixed-site-name a {
  color: #fff;
  text-decoration: none;
}
.mobile-bar__fixed-site-name a:hover {
  text-decoration: none;
}
.mobile-bar__university {
  margin-right: 1rem;
  margin-left: auto;
  line-height: 1;
}
.is-fixed .mobile-bar__university {
  display: none;
}

`;